var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgYoutubeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66658 10L10.1266 8.00004L6.66658 6.00004V10ZM14.3733 4.78004C14.4599 5.09337 14.5199 5.51337 14.5599 6.04671C14.6066 6.58004 14.6266 7.04004 14.6266 7.44004L14.6666 8.00004C14.6666 9.46004 14.5599 10.5334 14.3733 11.22C14.2066 11.82 13.8199 12.2067 13.2199 12.3734C12.9066 12.46 12.3333 12.52 11.4533 12.56C10.5866 12.6067 9.79325 12.6267 9.05992 12.6267L7.99992 12.6667C5.20658 12.6667 3.46659 12.56 2.77992 12.3734C2.17992 12.2067 1.79325 11.82 1.62659 11.22C1.53992 10.9067 1.47992 10.4867 1.43992 9.95337C1.39325 9.42004 1.37325 8.96004 1.37325 8.56004L1.33325 8.00004C1.33325 6.54004 1.43992 5.46671 1.62659 4.78004C1.79325 4.18004 2.17992 3.79337 2.77992 3.62671C3.09325 3.54004 3.66659 3.48004 4.54659 3.44004C5.41325 3.39337 6.20658 3.37337 6.93992 3.37337L7.99992 3.33337C10.7933 3.33337 12.5333 3.44004 13.2199 3.62671C13.8199 3.79337 14.2066 4.18004 14.3733 4.78004Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgYoutubeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/youtube-icon.be6021e8ec91ae71655345faea5459de.svg";